import { Box, Button, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import Layout from '@src/components/layout/Layout';
import List from './components/List';
import Edit from './components/Edit';
import ConsultantDTO from '@src/adapters/dto/consultant/ConsultantDTO';
import { useState } from 'react';
import Add from './components/Add';

const PREFIX = 'consultants';

const classes = {
  pageTitle: `${PREFIX}-pageTitle`,
  list: `${PREFIX}-list`,
  details: `${PREFIX}-details`,
  information: `${PREFIX}-information`,
};

const StyledLayout = styled(Layout)(({ theme }) => ({
  display: 'flex',

  [`& .${classes.pageTitle}`]: {
    padding: '0 20px 20px 20px',
    display: 'flex',
  },

  [`& .${classes.information}`]: {
    display: 'flex',
    justifyContent: 'space-between',
  },

  [`& .${classes.list}`]: {
    display: 'flex',
    justifyContent: 'space-between',
    height: '80vh',
    width: '60%',
    overflow: 'auto',
  },
  [`& .${classes.details}`]: { width: '38%' },
}));

function Consultants() {
  const [selectedConsultant, setSelectedConsultant] = useState<ConsultantDTO>();
  const [updatedConsultant, setUpdatedConsultant] = useState<ConsultantDTO>();
  const [addOpen, setAddOpen] = useState(false);

  const handleCancel = () => {
    setSelectedConsultant(undefined);
    setAddOpen(false);
  };

  const handleSaved = (consultant: ConsultantDTO) => {
    setUpdatedConsultant(consultant);
    setSelectedConsultant(undefined);
    setAddOpen(false);
  };

  const handleAdd = () => {
    setSelectedConsultant(undefined);
    setAddOpen(true);
  };

  const handleSelectConsultant = (consultant: ConsultantDTO) => {
    setSelectedConsultant(consultant);
    setAddOpen(false);
  };

  return (
    <StyledLayout>
      <Box className={classes.pageTitle}>
        <Typography variant="h4">Consultants</Typography>
        <Button onClick={handleAdd} color="primary">
          Add
        </Button>
      </Box>
      <Box className={classes.information}>
        <Paper elevation={8} className={classes.list}>
          <List
            selectConsultant={handleSelectConsultant}
            selectedConsultant={selectedConsultant}
            updatedConsultant={updatedConsultant}
          />
        </Paper>
        <Box className={classes.details}>
          {selectedConsultant && (
            <Edit
              consultant={selectedConsultant}
              cancel={handleCancel}
              saved={handleSaved}
            />
          )}
          {addOpen && (
            <Add cancel={handleCancel} saved={handleSaved} open={addOpen} />
          )}
        </Box>
      </Box>
    </StyledLayout>
  );
}

export default Consultants;
